export default __webpack_public_path__ + "static/media/end-game.68e17175.md";